var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPentagonTechnologyDeployment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 199,
    height: 173,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M197.27 86.5l-48.888 85H50.618L1.73 86.5l48.888-85h97.764l48.888 85z",
    stroke: "#E0621E",
    strokeWidth: 3
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTk5IiBoZWlnaHQ9IjE3MyIgdmlld0JveD0iMCAwIDE5OSAxNzMiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICA8cGF0aCBkPSJNMTk3LjI3IDg2LjVMMTQ4LjM4MiAxNzEuNUg1MC42MTc3TDEuNzMwNCA4Ni41TDUwLjYxNzcgMS41SDE0OC4zODJMMTk3LjI3IDg2LjVaIiBzdHJva2U9IiNFMDYyMUUiIHN0cm9rZS13aWR0aD0iMyIvPgo8L3N2Zz4K";
export { SvgPentagonTechnologyDeployment as ReactComponent };